<button   aria-label="logout" (click)="onClick()" type="button">{{"common.logout"|translate}}</button>